import { writable as storedWritable } from './_localStore.js'

const _savedDesign = storedWritable('savedDesign', {
  identifier: null,
  previouslySaved: false,
  name: null,
  email: null,
  mode: 'new',
  designId: null
})

export const savedDesign = {
  subscribe: _savedDesign.subscribe,
  set: _savedDesign.set,
  update: _savedDesign.update
}
